var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_common_fission_invite_code"},[_c('div',{staticClass:"invite-code-display",domProps:{"innerHTML":_vm._s(_vm.displayContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }